import React from 'react';
import { useLocation } from '../../contexts/LocationContext';
import { useInventoryData } from './inventory/useInventoryData';
import NewInventoryPanel from './inventory/NewInventoryPanel';
import ActiveInventoryTable from './inventory/ActiveInventoryTable';
import InventoryHistory from './inventory/InventoryHistory';
import SessionEditor from './inventory/SessionEditor';

const Inventory = () => {
  const { locationId } = useLocation();
  const inv = useInventoryData(locationId);

  return (
    <div style={{ fontSize: '12px' }}>
      {/* Page header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
        <span style={{ fontWeight: '600', fontSize: '13px' }}>Inwentaryzacja</span>
      </div>

      {/* Alerts */}
      {inv.error && (
        <div style={{ padding: '0.35rem 0.5rem', marginBottom: '0.5rem', backgroundColor: 'var(--danger-light)', color: 'var(--danger)', borderRadius: '4px', fontSize: '11px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          {inv.error}
          <button style={{  background: 'none', color: 'var(--danger)', padding: '0' }} onClick={() => inv.setError('')}>&times;</button>
        </div>
      )}
      {inv.success && (
        <div style={{ padding: '0.35rem 0.5rem', marginBottom: '0.5rem', backgroundColor: 'var(--success-light)', color: 'var(--success)', borderRadius: '4px', fontSize: '11px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          {inv.success}
          <button style={{  background: 'none', color: 'var(--success)', padding: '0' }} onClick={() => inv.setSuccess('')}>&times;</button>
        </div>
      )}

      {/* Compact tab bar */}
      <div style={{ display: 'flex', gap: '0.25rem', marginBottom: '0.5rem', padding: '0.35rem', backgroundColor: 'var(--card-bg)', borderRadius: '4px', border: '1px solid var(--border)', boxShadow: '0 1px 3px rgba(0,0,0,0.08)' }}>
        {[
          { key: 'new',     label: 'Nowa inwentaryzacja',   icon: 'fa-plus' },
          { key: 'history', label: 'Historia inwentaryzacji', icon: 'fa-history' }
        ].map(tab => (
          <button
            key={tab.key}
            style={{
              padding: '4px 10px', fontSize: '11px', fontWeight: inv.activeTab === tab.key ? '600' : '500',
              border: inv.activeTab === tab.key ? '1px solid var(--purple)' : '1px solid var(--border)',
              backgroundColor: inv.activeTab === tab.key ? 'var(--purple)' : 'var(--card-bg)',
              color: inv.activeTab === tab.key ? '#fff' : 'var(--text-secondary)',
              display: 'flex', alignItems: 'center', gap: '0.25rem'
            }}
            onClick={() => { inv.setActiveTab(tab.key); if (tab.key === 'new') inv.closeSession(); }}
          >
            <i className={`fas ${tab.icon}`} style={{ fontSize: '10px' }}></i>
            {tab.label}
          </button>
        ))}
      </div>

      {/* New inventory tab */}
      {inv.activeTab === 'new' && (
        <>
          {!inv.isInventoryStarted ? (
            <NewInventoryPanel
              inventoryType={inv.inventoryType}
              setInventoryType={inv.setInventoryType}
              categories={inv.categories}
              selectedCategory={inv.selectedCategory}
              setSelectedCategory={inv.setSelectedCategory}
              searchTerm={inv.searchTerm}
              setSearchTerm={inv.setSearchTerm}
              products={inv.products}
              selectedProducts={inv.selectedProducts}
              productSearchTerm={inv.productSearchTerm}
              setProductSearchTerm={inv.setProductSearchTerm}
              productSearchResults={inv.productSearchResults}
              addToSelectedProducts={inv.addToSelectedProducts}
              removeFromSelectedProducts={inv.removeFromSelectedProducts}
              clearSelectedProducts={inv.clearSelectedProducts}
              onStart={inv.startInventory}
              loading={inv.loading}
              locationId={locationId}
            />
          ) : (
            <ActiveInventoryTable
              inventoryData={inv.inventoryData}
              onCountChange={inv.updateInventoryCount}
              onCancel={inv.cancelInventory}
              onFinish={inv.finishInventory}
              onAddProduct={inv.addProductToActiveInventory}
              loading={inv.loading}
              locationId={locationId}
            />
          )}
        </>
      )}

      {/* History tab */}
      {inv.activeTab === 'history' && !inv.selectedSession && (
        <InventoryHistory
          inventorySessions={inv.inventorySessions}
          dateFilter={inv.dateFilter}
          setDateFilter={inv.setDateFilter}
          statusFilter={inv.statusFilter}
          setStatusFilter={inv.setStatusFilter}
          onRefresh={inv.loadInventorySessions}
          onOpenSession={inv.openSession}
          onViewSession={inv.viewSession}
        />
      )}

      {/* Session editor */}
      {inv.activeTab === 'history' && inv.selectedSession && (
        <SessionEditor
          selectedSession={inv.selectedSession}
          sessionItems={inv.sessionItems}
          loadingSession={inv.loadingSession}
          addProductSearch={inv.addProductSearch}
          setAddProductSearch={inv.setAddProductSearch}
          searchResults={inv.searchResults}
          onAddProduct={inv.addProductToSession}
          onUpdateCount={inv.updateSessionItemCount}
          onDeleteItem={inv.deleteSessionItem}
          onComplete={inv.completeSession}
          onBack={inv.closeSession}
          loading={inv.loading}
          readOnly={inv.isSessionReadOnly}
          saveErrors={inv.saveErrors}
        />
      )}
    </div>
  );
};

export default Inventory;
